import { Component } from '@verndale/core';

class LibraryBook extends Component {
  setupDefaults() {
    this.dom = {
      formatInputs: this.el.querySelectorAll('.library-search__format input'),
      hiddenFilters: this.el.querySelectorAll('.library-search__hidden-filter')
    };

    this.formatFilter = this.el.dataset.formatFilter;
  }

  addListeners() {
    this.dom.formatInputs?.forEach(input => {
      input.addEventListener('change', this.handleFormatChange.bind(this));
    });
  }

  handleFormatChange(e) {
    const { target } = e;
    const firstFilter = target.dataset.firstFilterValue;
    const secondFilter = target.dataset.secondFilterValue;

    const firstInput = this.dom?.hiddenFilters[0];
    const secondInput = this.dom?.hiddenFilters[1];

    if (!firstFilter || !secondFilter) {
      firstInput.name = '';
      secondInput.name = '';
    } else {
      firstInput.name = this.formatFilter;
      secondInput.name = this.formatFilter;
      firstInput.value = firstFilter;
      secondInput.value = secondFilter;
    }
  }
}

export default LibraryBook;
